// extracted by mini-css-extract-plugin
export default {"image":"lAV2rI"};